import { SelectValue } from '../../../Components/Base/Select/Select';
import { CalendarViewIntervalEnum } from '../Enums/CalendarViewInterval.enum';

export const TIMELINE_CALENDAR_SLOT_DURATION_OPTIONS: SelectValue[] = [
	{
		label: 'component.calendarViewSettings.slotDuration.per15minutes',
		value: CalendarViewIntervalEnum.FIFTEEN_MINUTES,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per20minutes',
		value: CalendarViewIntervalEnum.TWENTY_MINUTES,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per30minutes',
		value: CalendarViewIntervalEnum.THIRTY_MINUTES,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per1hour',
		value: CalendarViewIntervalEnum.ONE_HOUR,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per2hours',
		value: CalendarViewIntervalEnum.TWO_HOURS,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per4hours',
		value: CalendarViewIntervalEnum.FOUR_HOURS,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per6hours',
		value: CalendarViewIntervalEnum.SIX_HOURS,
	},
	{
		label: 'component.calendarViewSettings.slotDuration.per12hours',
		value: CalendarViewIntervalEnum.TWELVE_HOURS,
	},
];
